import Typography from "@material-ui/core/Typography";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles({
    emptyCell: {
        textAlign: 'center',
        padding: "1rem 0"
    }
});
const EmptyRow = (props) => {
    const classes = useStyles();
    return (
        <tr>
            <td colSpan={props.colSpan} className={classes.emptyCell} >
                <Typography variant="body2">
                    Nessun {props.text}
                </Typography>
            </td>
        </tr>
    )
}

EmptyRow.propTypes = {
    colSpan: PropTypes.number,
    text: PropTypes.string
}
export default EmptyRow;
